// import React from 'react'
// import useUserAuth from '../../hooks/useUserAuth';
// import { UserContext } from '../../context/UserContext';
// import { useContext } from 'react';
// import Navbar from './Navbar';
// import SideMenu from './SideMenu';

// const DashboardLayout = ({children,activeMenu}) => {
//     useUserAuth()
  
//     const { user } = useContext(UserContext);
//   return (
//     <div className=''>
//       <Navbar activeMenu={activeMenu}/>
      
//       {user && (
//         <div className="flex">
//         <div className="max-[1080px]:hidden"><SideMenu activeMenu={activeMenu}/></div>
//         <div className="grow mx-5">{children}
//         </div>
        
//     </div>
//   )}
  
//     </div>)}

// export default DashboardLayout;
import React, { useContext } from 'react';
import useUserAuth from '../../hooks/useUserAuth';
import { UserContext } from '../../context/UserContext';
import Navbar from './Navbar';
import SideMenu from './SideMenu';

const DashboardLayout = ({ children, activeMenu }) => {
  useUserAuth();

  const { user } = useContext(UserContext);

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {/* Navbar fixe en haut */}
      <Navbar activeMenu={activeMenu} />

      {user && (
        <div className="flex flex-1 overflow-hidden">
          {/* Menu latéral fixe à gauche */}
          <div className="max-[1080px]:hidden w-64 flex-shrink-0 border-r">
            <SideMenu activeMenu={activeMenu} />
          </div>

          {/* Contenu scrollable */}
          <div className="flex-1 overflow-y-auto px-5 py-4 bg-gray-50">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardLayout;
